import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _class;
import { Translator } from "./";
import { ApolloClient, ApolloLink, HttpLink, InMemoryCache, split } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import * as FingerprintJS from '@fingerprintjs/fingerprintjs';
import { message, Modal, notification } from 'antd';
import { AxiosError } from 'axios';
import { createClient } from 'graphql-ws';
import _ from 'lodash';
import { Authenticator } from "./authenticator";
export var Requester = /*#__PURE__*/function () {
  function Requester() {
    _classCallCheck(this, Requester);
  }
  _createClass(Requester, null, [{
    key: "initialize",
    value: function initialize() {
      var _this = this;
      FingerprintJS.load().then(function (agent) {
        return agent.get();
      }).then(function (result) {
        _this.instanceMetadata.headers['X-Visitor-Id'] = result.visitorId;
      });
    }
  }, {
    key: "handleRequest",
    value: function handleRequest(requestOptions) {
      // 初始化上下文
      // > 请求地址
      if (requestOptions.url && this.instanceMetadata.baseURL) {
        if (!requestOptions.url.startsWith('http')) {
          requestOptions.url = "".concat(this.instanceMetadata.baseURL).concat(requestOptions.url);
        }
      }
      // > 请求头
      requestOptions.headers = _objectSpread(_objectSpread({}, this.instanceMetadata.headers), requestOptions.headers);
      // 处理上下文
      // > Authorization
      // > > -
      var accessToken = [window.localStorage, window.sessionStorage].map(function (storage) {
        return storage.getItem("JiShuXin['Authorization']['accessToken']");
      }).filter(_.isString).at(0);
      // > > -
      if (accessToken) {
        requestOptions.headers['Authorization'] = "Bearer ".concat(accessToken);
      }
      // 返回上下文
      return requestOptions;
    }
  }, {
    key: "handleResponse",
    value: function handleResponse(response) {
      var _this2 = this;
      // -
      var buildAxiosError = function buildAxiosError(message) {
        return new AxiosError(message || response.data.message, AxiosError.ERR_BAD_RESPONSE, response.config, response.request, response);
      };
      // -
      switch (response.data.code) {
        case 200:
          {
            // 减少一层 data 层数
            response.data = response.data.data;
            // -
            return response;
          }
        case 401:
          {
            // 处理数据
            // > 如果不是登录页则进行提醒
            if (!Authenticator.isAnonymousAccessible(window.location.pathname)) {
              // 如果没有提醒过则进行提醒
              if (!this.instanceAlerting) {
                // 标记为已进行提醒
                this.instanceAlerting = true;
                // -
                Modal.confirm({
                  centered: true,
                  title: Translator.formatMessage({
                    id: 'Invalid credentials'
                  }),
                  content: Translator.formatMessage({
                    id: 'The current login credentials have expired. Please log in again.'
                  }),
                  onOk: Authenticator.redirect,
                  onCancel: function onCancel() {
                    _this2.instanceAlerting = false;
                  }
                });
              }
            }
            // > 进行数据清理
            [window.localStorage, window.sessionStorage].forEach(function (storage) {
              return storage.removeItem("JiShuXin['Authorization']['accessToken']");
            });
            // 重新抛出报错
            throw buildAxiosError(Translator.formatMessage({
              id: 'Invalid credentials'
            }));
          }
        default:
          {
            // 处理数据
            notification.error({
              message: response.data.reason || 'Oops!',
              description: response.data.message
            });
            // 重新抛出报错
            throw buildAxiosError();
          }
      }
    }
  }]);
  return Requester;
}();
_class = Requester;
_defineProperty(Requester, "instance", new ApolloClient({
  cache: new InMemoryCache(),
  link: ApolloLink.from([setContext(function () {
    return _class.handleRequest({});
  }), onError(function (_ref) {
    var graphQLErrors = _ref.graphQLErrors,
      networkError = _ref.networkError;
    // -
    if (graphQLErrors) {
      graphQLErrors.forEach(function (graphQLError) {
        try {
          var _graphQLError$extensi;
          _class.handleResponse({
            data: {
              code: {
                AUTH_ERROR: 401,
                UNAUTHORIZED_FIELD_OR_TYPE: 401
              }[(_graphQLError$extensi = graphQLError.extensions) === null || _graphQLError$extensi === void 0 ? void 0 : _graphQLError$extensi.code],
              message: graphQLError.message
            }
          });
        } catch (error) {}
      });
    }
    // -
    if (networkError) {
      message.error(networkError.message);
    }
  }), split(function (_ref2) {
    var query = _ref2.query;
    // -
    var definition = getMainDefinition(query);
    // -
    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
  }, new GraphQLWsLink(createClient({
    url: function url() {
      return "".concat(_class.instanceMetadata.baseURL.replace(/^http/i, 'ws'), "/v1/graphql");
    }
  })), new HttpLink({
    credentials: 'include',
    uri: function uri(operation) {
      return "".concat(_class.instanceMetadata.baseURL, "/v1/graphql?operationName=").concat(operation.operationName);
    }
  }))])
}));
_defineProperty(Requester, "instanceAlerting", false);
_defineProperty(Requester, "instanceMetadata", {
  baseURL: '',
  headers: Object.create(null)
});